import React from "react";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";

export function Layout({ children, footer = true }) {
  return (
    <div className="min-h-screen bg-[#0B0E14]">
      <Header />
      <main>{children}</main>
      {footer && <Footer />}
    </div>
  );
}
